import { Directive, ElementRef, Inject } from '@angular/core';

import { DigitOnlyBase } from './digit-only-base';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfDigitOnly]'
})
export class DigitOnlyDirective extends DigitOnlyBase {
  regex = /\D/g;
  constructor(@Inject(ElementRef) elementRef: ElementRef) {
    super(elementRef);
  }

  allowKey(e: KeyboardEvent): boolean {
    if (e.key === '-' || e.key === '.') {
      return false;
    }
    if (e.code) {
      if (e.code === 'Minus' || e.code === 'Period') {
        return false;
      }
    }
    return true;
  }
}
